import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import Button from '@/shared/Button'
import FormItem from '@/shared/FormCreator/FormItem'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { styled } from '@mui/material/styles'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import Close from '@mui/icons-material/HighlightOff'
import InputAdornment from '@mui/material/InputAdornment'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import * as Yup from 'yup'

const mapStateToProps = ({ loading }) => ({ isLoading: loading['testCompany/create'] })

const CustomTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '3px',
    '& fieldset': { borderColor: theme.palette.secondary_80.main },
  },
}))

const FileInput = styled('input')({
  display: 'none',
})

const inputConfig = {
  variant: 'standard',
  inputBaseProps: {
    labelSuffix: '',
    flexDirection: 'column',
    alignItems: 'stretch',
    spacing: 0,
  },
  endAdornment: args => {
    const { value, inputProps } = args

    const { maxLength } = inputProps || {}

    if (maxLength) {
      return (
        <Typography
          variant="caption"
          sx={{ color: '#00000040', fontSize: '14px !important' }}
        >{`${value.length}/${maxLength}`}</Typography>
      )
    }
    return null
  },
}

const btnProps = {
  size: 'small',
  sx: { borderRadius: 2, padding: 0, color: theme => theme.palette.secondary_80.main },
}

const iconProps = {
  sx: {
    padding: 0.5,
  },
}

const CreateTestCompanyCard = ({
  dispatch,
  isLoading,
  onClose,
  onComplete,
  value,
  key,
  field,
  onFileChange,
  onChange,
  handleDeleteField,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const uploadRef = useRef(null)
  const { t } = useTranslation()
  const [fileName, setFileName] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [companyName, setCompanyName] = useState('')
  const [check, setCheck] = useState(false)

  const validations = Yup.object().shape({
    testCompanyName: Yup.string()
      //   .matches(
      //     /^[a-zA-Z\u4e00-\u9fa5]+$/,
      //     'Only letters (a-z, A-Z) and Chinese characters are allowed',
      //   )
      .max(20, 'Company name cannot exceed 20 characters')
      .required(t('validation.test_company_name_required')),
  })

  const {
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(Yup.object().shape(validations)),
  })

  const isDisable = () => {
    if (
      errors !== null &&
      //   field.fileName !== null &&
      //   field.file !== null &&
      field.name !== null &&
      field.name !== ''
    ) {
      setCheck(true)
    } else {
      setCheck(false)
    }
  }

  const handleInputChange = (name, data) => {
    if (data === Object) {
      onChange(field.id, name, data?.target?.value ?? '')
    } else {
      onChange(field.id, name, data ?? '')
    }
    isDisable()
  }

  const handleFileChange = event => {
    const file = event.target.files[0]
    if (
      file &&
      (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg')
    ) {
      onChange(field.id, 'file', file)
    } else {
      dispatch({
        type: 'app/notify',
        payload: { message: t('errors.image_format'), severity: 'error' },
      })
    }
    isDisable()
  }

  const handleButtonClick = () => {
    uploadRef.current.click()
  }

  useEffect(() => {
    if (field) {
      setFileName(field.fileName)
      setCompanyName(field.name)
    }
    isDisable()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field])

  useEffect(() => {
    if (check) {
      onChange(field.id, 'check', true)
    } else {
      onChange(field.id, 'check', false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [check])

  return (
    <Box>
      <Grid container spacing={2} my={1} alignItems="center">
        <Grid item xs={6}>
          <FormItem
            id={key}
            defaultValue={field.name || ''}
            // value={companyName}
            name="testCompanyName"
            control={control}
            // onComplete={(e) => isFileName(e)}
            inputConfig={{
              ...inputConfig,
              inputProps: { maxLength: 20 },
              onChange: e => handleInputChange('name', e),
            }}
            errors={errors}
          />
        </Grid>

        <Grid item xs={5} style={{ display: 'flex', alignItems: 'center' }}>
          <CustomTextField
            variant="outlined"
            size="small"
            value={fileName}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <FileInput
                    ref={uploadRef}
                    name="uploadRef"
                    type="file"
                    accept="image/JPEG, image/JPG, image/PNG"
                    onChange={handleFileChange}
                  />
                  <Button
                    variant="contained"
                    component="span"
                    color={'secondary_80'}
                    size="medium"
                    sx={{
                      width: 50,
                      mr: '-14px',
                      border: theme => `1px solid ${theme.palette.secondary_80.main}`,
                      borderRadius: '0px 3px 3px 0px',
                    }}
                    onClick={handleButtonClick}
                  >
                    {t('general.browse')}
                  </Button>
                </InputAdornment>
              ),
            }}
            style={{ flex: 1 }}
          />
        </Grid>
        <Grid item xs>
          {!check && (
            <IconButton
              {...btnProps}
              onClick={() => {
                handleDeleteField(field.id)
              }}
            >
              <Close {...iconProps} />
            </IconButton>
          )}
          {check && (
            <IconButton {...btnProps}>
              <CheckCircleIcon color="primary" />
            </IconButton>
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
export default connect(mapStateToProps)(CreateTestCompanyCard)
